export default "__VITE_ASSET__DbVgvwcv__"